import React, { useEffect, useState } from 'react'
import { axiosPrivate } from '../../../Apis/axios';

function Create(props) {

    const url = "/roles";
    const [error, setError] = useState();  
    const [success, setSuccess] = useState();  
    const [submit, setSubmit] = useState("Create");

    const [options, setOptions] = useState();

    useEffect(()=>{
        let opt = [];

        if(props.hasOwnProperty("opt")) opt = props.opt; 

        if(opt){
            const optionsArray =  opt.map((item)=> {
                return (
                    <option key={item.id} value={item.id}>
                        {item.title}
                    </option>
                )
            });
        
             setOptions(optionsArray)
        }
        
    }, [props])
    

    async function handleCreate(event){
        event.preventDefault();
        event.target.elements.submitBtn.disabled = true;
        setSubmit(<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Loading...</>)

        const inputValues = {
            title: event.target.elements.title.value,
            slug: event.target.elements.slug.value,
            description: event.target.elements.description.value
        }

        //console.log(event.target.elements.permissions.selectedOptions[0].value, "now here");
        const permissionsInput = event.target.elements.permissions.selectedOptions;
        
        try{
            // Axios API.
            const response = await axiosPrivate.post(url, 
                JSON.stringify(inputValues), 
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
                
                
            if((response.status == 200) && (permissionsInput.length > 0)){
                const permissionsArray = Array.from(permissionsInput).map((item) => item.value);
                await axiosPrivate.post("/roles/permissions",
                JSON.stringify({
                    id: response.data.data.id,
                    permissions: permissionsArray
                }));
            } 

            event.target.elements.submitBtn.disabled = false;
            setSubmit("Create");


            // Print Out Responses.
            // console.log(response?.data);
            setSuccess("Role created successfully.");
            window.location.reload(false);

        }catch(e){
            event.target.elements.submitBtn.disabled = false;
            setSubmit("Create");
            setSuccess("");
            if (e.response.data.error.hasOwnProperty("errors")){
                setError(e.response.data.error.errors[0].message);
            }else{
                setError(e.response.data.error);
                console.error(e);
            }
        }
    }

  return (
    <div className="modal fade" id="roleModal" tabIndex="-1" role="dialog" aria-labelledby="#roleModal" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content border-0">
                    <form onSubmit={handleCreate}>
                        <div className="modal-header py-2 text-white bg-dark">
                            <h5 className="modal-title" id="exampleModalLongTitle">Create Role</h5>
                        </div>
        
                        <div className="modal-body py-3">
                        <span className="text-danger small"><b>{error}</b></span>
                        <span className="text-success small"><b>{success}</b></span>

                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="titleInput" className='font-weight-medium'>Name: <span className='text-danger'>*</span></label>
                                    <input type="text" id='titleInput' name='title' className='form-control form-control-sm'  placeholder='Role name' required />
                                </div>
                                <div className="col-md-6"></div>
                            </div>
    
                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="iconInput" className='font-weight-medium'>Slug: <span className='text-danger'>*</span></label>
                                    <input type="text" id='iconInput' name='slug' className='form-control form-control-sm'  placeholder='Role slug' required />
                                </div>
                                <div className="col-md-6"></div>
                            </div>

                            <div className="row py-2">
                                <div className="col-md-6">
                                    <label htmlFor="iconInput" className='font-weight-medium'>Permissions: <span className='text-danger'></span></label>
                                    <select name="permissions" id="" className='form-control form-control-sm' multiple>
                                        {/* <option value={0}> None </option> */}
                                        {options}
                                    </select>
                                </div>
                                <div className="col-md-6"></div>
                            </div>
    
                            <div className="row py-2">
                                <div className="col-md-10">
                                    <label htmlFor="descInput" className='font-weight-medium'>Description: </label>
                                    <textarea className='form-control form-control-sm' name="description" id="descInput" cols="30" rows="3"></textarea>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                        </div>

                        <div className="modal-footer py-1">
                            <button type="button" className="btn btn-sm btn-dark" data-dismiss="modal" aria-label="Close">Close</button>
                            <button type="submit" name="submitBtn" className="btn btn-danger btn-sm">
                                {submit}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
  );
}

export default Create;